<div class="auto-scroll">
  <div class="headers-background"></div>
  <table mat-table [dataSource]="dataSource" matSort class="no-cell-border-bottom" #table>
    <ng-container [matColumnDef]="rowKeys.name" sticky>
      <th
        mat-header-cell
        *matHeaderCellDef
        mat-sort-header
        [disabled]="!isSortable"
        class="fixed-column"
        (click)="changeSort()"
      >
        <ds-lib-search-bar
          class="byd-search-bar"
          *ngIf="isSearchDisplayed"
          [searchControl]="searchControl"
          [placeholder]="filterPlaceholder"
          (blurEmitter)="searchBlur.emit()"
          (click)="$event.preventDefault()"
        >
        </ds-lib-search-bar>
        <h3>
          {{ fixedColumn }}
        </h3>
      </th>
      <td
        mat-cell
        *matCellDef="let element; let j = index"
        class="border-right fixed-row"
        [ngClass]="{ 'colored-row': !(j % 2) }"
        [ngStyle]="{ width: fixedColumnWidth ? fixedColumnWidth + 'px' : undefined }"
      >
        <mat-checkbox
          *ngIf="canSelectRow"
          [checked]="selectedRows.includes(element[rowKeys.id])"
          (change)="selectRowToggle(element, $event)"
        ></mat-checkbox>
        <div>
          <p>{{ element[rowKeys.name] }}</p>
          <p>{{ element[rowKeys.subtitle] }}</p>
        </div>
        <ds-lib-help
          *ngIf="element[rowKeys.info]"
          [wholeText]="element[rowKeys.info]"
          matTooltipClass="tooltip-multiline-medium"
        ></ds-lib-help>
      </td>
    </ng-container>
    <ng-container *ngFor="let header of currentHeaders; let i = index" matColumnDef="{{ header.headerId }}">
      <th
        mat-header-cell
        *matHeaderCellDef
        [ngStyle]="{ 'min-width': boxSize + 'px', 'max-width': boxSize + 'px' }"
        class="rotate"
        (click)="headerClicked(header)"
      >
        <div>{{ header.name }}</div>
      </th>
      <td
        mat-cell
        *matCellDef="let element; let j = index"
        class="box border-right"
        [ngClass]="{ 'colored-row': !(j % 2), 'disabled-row': header.disabled }"
        [ngStyle]="{ height: boxSize + 'px' }"
        (click)="toggleBox(element, header)"
      >
        <div class="c-box" [ngClass]="{ selected: element[rowKeys.selected][header[selectedKey]] }"></div>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
